import CustomizeBranding from './components/CustomizeBranding';

const ManageBranding=() => {
  return (
    <CustomizeBranding/>
  );
};

export default ManageBranding;